// extracted by mini-css-extract-plugin
export default {"icon":"calendar-legend-module--icon--3cfba","wrapper":"calendar-legend-module--wrapper--d0f56"};